export default __webpack_public_path__ + "static/media/dom-dom-ziki.aebae8e8.png";